var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "action",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history-clock-time-recent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5486056 4.0774757c-3.8232046-4.72126449-10.74986541-5.44928588-15.4711299-1.62608128-4.72126449 3.82320461-5.44928588 10.74986538-1.62608128 15.47112988 3.82320461 4.7212645 10.74986538 5.4492859 15.47112988 1.6260813 2.7783464-2.2498606 4.1738212-5.574457 4.0727126-8.891895l-.5046068-.1103929-1.5242031-.3334502c.250073 2.8787017-.8879421 5.8261405-3.3025435 7.7814462-3.8628527 3.1280764-9.53012066 2.5324226-12.65819715-1.3304302-3.1280765-3.8628527-2.53242264-9.53012066 1.33043013-12.65819715 3.86285277-3.1280765 9.53012072-2.53242264 12.65819722 1.33043013l-2.3314379 1.88796117 6.2551858 1.36844825-.0380181-6.40301137z",
    fill: "#f2c500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "m12 4h-2v7.4142136l4.8284271 4.8284271 1.4142136-1.4142136-4.2426407-4.2426407z",
    fill: "#8f3faf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.31dd056095016f55ba67c4755bd42e5f.svg";
export { ForwardRef as ReactComponent };